import React, { useEffect, useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { enableMXForIDF, ezsServiceIds, idfServiceIds, isLMSComplete } from "../config/UserServicesList";
import { useAreServicesActive, useCheckAnyServiceActive } from "../util/CommonServices";
import { monitoringServiceList, idfMonitoringServiceList, businessMonitoringServiceList } from "../components/Monitoring/MonitoringServiceActive";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { CommonContext } from "../CommonContextProvider";
import BreachesNavIcon from "../Assets/images/breach_nav.svg";
import { useResourceTabPermission } from "../util/CommonServices";
import * as ProductFeatureAction from "../store/productFeatureService/actions";
import { breachServiceActive } from "../util/CommonBreach";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface INavbar {
    renderFamilyService?: any;
    requestLogout?: any;
}
export const Navbar = ({ renderFamilyService, requestLogout }: INavbar) => {
    const supportInternational = useSelector(
        (state: ApplicationState) =>
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.supportInternational
    );
    const { creditDynamicRoute }: any = useContext(CommonContext);
    const userServices = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
            ? state.loggedInUser.userServiceDetails.userServices
            : []
    );
    const breachSummaryData = useSelector((state: ApplicationState) =>
        state.breachSummaryState ? (state.breachSummaryState.breachSummaryData ? state.breachSummaryState.breachSummaryData : null) : null
    );
    const subcustomerId = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.subcustomerId
            ? state.loggedInUser.activeAccount.subcustomerId
            : ""
    );
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const [country, setCountry] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const { t: tLang } = useTranslation();
   
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const hasPurchaseCreditReport = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.hasPurchaseCreditReport);
    const hasOneTimeScore = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeScore);
    const hasOneTimeReport = useSelector((state: ApplicationState) => state.creditHistoryData && state.creditHistoryData.hasOneTimeReport);
    const [showCreditActivity, setShowCreditActivity] = useState(false);
    const yodleeServiceList = [idfServiceIds.bankAndCreditCardActivity, ezsServiceIds.financialTransactionMonitoring];
    const history = useHistory();
    const creditScoreServiceList = [
        ezsServiceIds.monthlyCreditScore,
        ezsServiceIds.quarterlyCreditScore,
        ezsServiceIds.tuDailyCreditScore,
        ezsServiceIds.tuMonthlyCreditScore,
        ezsServiceIds.tuQuarterlyCreditScore,
        ezsServiceIds.tuAnnualCreditScore,
        ezsServiceIds.tuCanadaCreditScore,
        idfServiceIds.threeBureauCreditScores,
        idfServiceIds.transUnionCreditScore,
    ];
    const isAnyServiceActive = useCheckAnyServiceActive();
    const isCreditBureauInformationActive = useAreServicesActive([
        ezsServiceIds.businessCreditServiceBusinessCredit,
        ezsServiceIds.businessCreditServiceBusinessCreditPro,
        ezsServiceIds.businessCreditServiceBusinessCreditSelect,
    ]);
    const CyberActiveServices = useAreServicesActive([ezsServiceIds.businessBreachFulfillmentSupport]);

    const IncidentActiveServices = useAreServicesActive([ezsServiceIds.businessIncidentResponseForensics]);

    const showMyReputation = useAreServicesActive([ezsServiceIds.myReputation, idfServiceIds.myReputation]);

    const creditReportServiceList = [
        ezsServiceIds.experianCreditReport,
        ezsServiceIds.experianCreditReportwithScore,
        ezsServiceIds.experianAnnualCreditReportWithScore,
        ezsServiceIds.creditReportForEachOf3Bureaus,
        ezsServiceIds.creditReportForEachOf3BureausWithScore,
        ezsServiceIds.experianAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.oneBureauQuarterlyCreditReport,
        ezsServiceIds.oneBureauMonthlyCreditReport,
        ezsServiceIds.transCreditReport,
        idfServiceIds.threeBureauCreditReports,
        idfServiceIds.transUnionCreditReport,
        // ezsServiceIds.tuCreditReport,
        ezsServiceIds.tuDailyCreditReport,
        ezsServiceIds.tuMonthlyCreditReport,
        ezsServiceIds.tuQuarterlyCreditReport,
        ezsServiceIds.tuAnnualCreditReport,
        // ezsServiceIds.tuCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3Bureaus,
        ezsServiceIds.tuAnnualCreditReportForEachOf3Bureaus,
        // ezsServiceIds.tuCreditReportWithScore,
        ezsServiceIds.tuDailyCreditReportWithScore,
        ezsServiceIds.tuMonthlyCreditReportWithScore,
        ezsServiceIds.tuQuarterlyCreditReportWithScore,
        ezsServiceIds.tuAnnualCreditReportWithScore,
        ezsServiceIds.tuOneTimeCreditReportWithScore,
        // ezsServiceIds.tuCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuMonthlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuQuarterlyCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuAnnualCreditReportForEachOf3BureausWithScore,
        ezsServiceIds.tuCanadaMonthlyCreditReportWithScore,
        ezsServiceIds.tuCanadaQuarterlyCreditReportWithScore,
        ezsServiceIds.tuCanadaAnnualCreditReportWithScore,
        ezsServiceIds.tuCanadaOneTimeCreditReportWithScore,
        ezsServiceIds.tuCanadaCreditMonitoring,
        ezsServiceIds.tuCanadaQuarterlyCreditReport,
    ];
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const showTopNav: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.navigationTop
            ? state.configurationState.configuration.partnerConfig.navigationTop
            : ""
    );
    const isEsetId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2652
                ? true
                : false
            : false
    );
    const isSSOUser: boolean = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState._unifiedAccountInfo && state.myAccountServiceState._unifiedAccountInfo.isSSOUser
            ? state.myAccountServiceState._unifiedAccountInfo.isSSOUser
            : false
    );
    const isYodleeTransactionServiceActive = useAreServicesActive(yodleeServiceList) && !enableMXForIDF;
    const isYodleeServiceEnabled = useAreServicesActive(yodleeServiceList) && enableMXForIDF;
    const isCreditScoreActive = useAreServicesActive(creditScoreServiceList) || (hasPurchaseCreditReport && hasOneTimeScore);
    const isCreditReportActive = useAreServicesActive(creditReportServiceList) || (hasPurchaseCreditReport && hasOneTimeReport);
    const isMonitoringServiceActive = useAreServicesActive(monitoringServiceList);
    const isIDFMonitoringServiceActive = useAreServicesActive(idfMonitoringServiceList);
    const isBusinessMonitoringServiceActive = useAreServicesActive(businessMonitoringServiceList);
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );

    const mxServiceList = [ezsServiceIds.financialTransactionMonitoringMX];
    const isLmsActiveService = useAreServicesActive([ezsServiceIds.businessLearningManagementSystem]);
    const ismxServiceActive = useAreServicesActive(mxServiceList) || isYodleeServiceEnabled;
    const isCCAMActive = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo?.hasCCAM ? true : false));
    const isIdfCCAMServiceActive = useAreServicesActive([idfServiceIds.childCreditActivityMonitoring]);

    const dispatch = useDispatch();
    const requestProductFeatureOfBidr = (forcefullyRefresh: boolean) => dispatch(ProductFeatureAction.actionCreators.requestProductFeature(forcefullyRefresh));
    const [alerts, setAlerts] = useState(false);
    const alertData: any = useSelector((state: ApplicationState) => (state.alertState && state.alertState.alertData ? state.alertState.alertData : []));
    const hasAlert = alertData && alertData.length > 0;
    const checkAlerts = () => {
        setAlerts(alertData.length > 0);
    };

    const productFeatureOfBIDR = useSelector((state: ApplicationState) => state.productFeatureState?.productFeatureData);
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );

    const setCountryInfo = () => {
        let currentCountry = accountInfo?.country ?? "";
        if (currentCountry !== country) {
            setCountry(currentCountry)
        }
    };

    useEffect(() => {
        setCountryInfo();
    }, [accountInfo, country]);

    const toggleMenuBar = () => {
        setIsOpen(!isOpen);
    };

    let isEducationAndBreachVisible = hasEducationAndBreach;

    const displaySecurityAssessment = useResourceTabPermission(productFeatureOfBIDR?.SecurityAssessmentEnabled);
    const displayCyberRiskProfile = useResourceTabPermission(productFeatureOfBIDR?.AllowWhiteHawkAssessment);
    const displayBreachReadiness = useResourceTabPermission(productFeatureOfBIDR?.BreachReadinessKitEnabled);

    const prepareScript = () => {
        requestProductFeatureOfBidr(false);
        checkAlerts();
        // Toggle Main Menu
        var toggleMenu = document.querySelector("#nav-main-btn");
        var toggleMenuIcon = document.querySelector("#nav-main-btn .btn-icon > em");
        var navMenu = document.querySelector("#nav-main");
        if (toggleMenu) {
            toggleMenu.addEventListener("click", function () {
                if (navMenu && toggleMenuIcon && toggleMenu) {
                    if (navMenu.classList.contains("is-active")) {
                        navMenu.classList.remove("is-active");
                        toggleMenu.setAttribute("aria-expanded", "false");
                        toggleMenuIcon.classList.remove("la-times");
                        toggleMenuIcon.classList.add("la-bars");
                    } else {
                        if (navMenu && toggleMenuIcon) {
                            navMenu.classList.add("is-active");
                            toggleMenu.setAttribute("aria-expanded", "true");
                            toggleMenuIcon.classList.add("la-times");
                            toggleMenuIcon.classList.remove("la-bars");
                        }
                    }
                }
            });
        }

        // Toggle User Area Menu
        var toggleUser = document.querySelector("#user-profile-btn");
        var userMenu = document.querySelector("#user-profile");

        if (toggleUser) {
            toggleUser.addEventListener("click", function () {
                if (userMenu && toggleUser && userMenu.classList.contains("is-active")) {
                    userMenu.classList.remove("is-active");
                    toggleUser.setAttribute("aria-expanded", "false");
                } else {
                    if (userMenu && toggleUser) {
                        userMenu.classList.add("is-active");
                        toggleUser.setAttribute("aria-expanded", "true");
                    }
                }
            });
        }

        // Press Escape and close all dropdowns and Menu if toggled
        window.onkeydown = function (event: { keyCode: number }) {
            if (event.keyCode === 27) {
                // Hide Nav Menu
                if (navMenu && toggleMenuIcon && userMenu && toggleUser) {
                    navMenu.classList.remove("is-active");
                    navMenu.setAttribute("aria-expanded", "false");
                    toggleMenuIcon.classList.remove("la-times");
                    toggleMenuIcon.classList.add("la-menu");

                    // Hide User Profile Menu
                    userMenu.classList.remove("is-active");
                    toggleUser.setAttribute("aria-expanded", "false");
                }
            }
        };
    };

    useEffect(prepareScript, []);

    function toggleMenu(e: any) {
        const toggleMenuIcon = document.querySelector("#nav-main-btn .btn-icon > em");
        const navMenu = document.querySelector("#nav-main");
        if (navMenu && toggleMenuIcon) {
            if (navMenu.classList.contains("is-active")) {
                navMenu.classList.remove("is-active");
                navMenu.setAttribute("aria-expanded", "false");
                toggleMenuIcon.classList.remove("la-times");
                toggleMenuIcon.classList.add("la-bars");
            }
        }

        // remove focus from selected item
        if (e.target.classList.contains("nav-link")) {
            e.target.blur();
        } else {
            e.target.parentNode.blur();
        }
    }

    const showCreditMenu = () => {
        if (isBusinessUser && isCreditBureauInformationActive) {
            return true;
        } else if (!isBusinessUser) {
            return supportInternational ? isCreditReportActive || isCreditScoreActive || country === "US" : true;
        } else {
            return false;
        }
    };

    const showResourceMenu = () => {
        if (isBusinessUser) {
            return true;
        }else if(supportInternational && country !== "US"){
            return false;
        }else if(country  === "US"){
            return true;
        }
         else {
            return  displaySecurityAssessment || displayCyberRiskProfile || displayBreachReadiness || isEducationAndBreachVisible ;
        }   
    };

    const breachServiceAvailable = () => {
        if (breachService && breachService.isBreachClarityInCatalog) {
            return true;
        }
        return false;
    };

    const employeeServiceAvailable = () => {
        if (userServices.length) {
            let employeeService = userServices.find((item) => item.serviceCode === "SVC-SMB-MAV");
            if (employeeService && Object.keys(employeeService).length) {
                return true;
            }
        }
        return false;
    };

    useEffect(() => {
        if (!isPrimaryAccount) {
            const currentFamilyAccount = familyMembers.find((x) => x.subcustomerId === subcustomerId);
            if (currentFamilyAccount && currentFamilyAccount.showCreditActivity) {
                setShowCreditActivity(currentFamilyAccount.showCreditActivity);
            }
        }
    }, [subcustomerId]);

    return (
        <React.Fragment>
            <div
                className={`${showTopNav ? "top-nav-main" : "nav-main"}`}
                id="nav-main"
                aria-labelledby="title-navigation"
                onClick={!showTopNav ? toggleMenu : () => {}}
                onKeyPress={!showTopNav ? toggleMenu : () => {}}
                role="navigation"
            >
                {!showTopNav && (
                    <h3 className="sr-only" id="title-navigation">
                        Navigation
                    </h3>
                )}
                <ul className="list-reset" role="menu">
                    {isAnyServiceActive && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                exact
                                to="/dashboard"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Dashboard" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-home"></em>
                                </span>
                                <span className="nav-text">
                                    {!renderSiteInIFrame ? (isEsetId ? tLang("leftHandNavigation.overview") : tLang("leftHandNavigation.dashboard")) : "Hub"}
                                </span>
                            </NavLink>
                        </li>
                    )}

                    {isAnyServiceActive && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/identity-vault"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Identity Vault" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-id-card"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.identityVault")}</span>
                            </NavLink>
                        </li>
                    )}

                    {isAnyServiceActive && breachServiceAvailable() && breachServiceActive(breachService) ? (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/breaches"
                                role="menuitem"
                                className="nav-link "
                                style={{ padding: showTopNav ? "0.6rem 0rem" : "none" }}
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "breaches" })}
                            >
                                <span className="nav-icon top-30" aria-hidden="false" style={{ top: "30%" }}>
                                    <img src={BreachesNavIcon} alt="Folder Icon" />
                                </span>

                                <span className="nav-text">
                                    <span>{tLang("leftHandNavigation.breachiq")}</span>
                                    <span style={{ verticalAlign: "super", fontSize: "0.6rem" }}>TM</span>

                                    {breachSummaryData &&
                                    breachSummaryData.detectedBreachSummary &&
                                    breachSummaryData.detectedBreachSummary.newDetectedBreachCount ? (
                                        <span className="new-detected-breach-count">{breachSummaryData.detectedBreachSummary.newDetectedBreachCount}</span>
                                    ) : null}
                                </span>
                            </NavLink>
                        </li>
                    ) : null}

                    {isAnyServiceActive && isPrimaryAccount && breachServiceAvailable() && !breachServiceActive(breachService) ? (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/breaches"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "breaches" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <img src={BreachesNavIcon} alt="Folder Icon" />
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.breachSearch")}</span>
                            </NavLink>
                        </li>
                    ) : null}

                    {showMyReputation && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/my-reputation"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav My Reputation" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-users"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.myReputation")}</span>
                            </NavLink>
                        </li>
                    )}
                    {(isBusinessMonitoringServiceActive ||
                        isMonitoringServiceActive ||
                        isIDFMonitoringServiceActive ||
                        (isAnyServiceActive && alerts) ||
                        (isAnyServiceActive && hasAlert)) && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/monitoring"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Monitoring" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-bell"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.alerts")}</span>
                            </NavLink>
                        </li>
                    )}
                    {isAnyServiceActive && showCreditMenu() && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to={creditDynamicRoute}
                                isActive={(match, location) => {
                                    return location?.pathname?.startsWith("/credit");
                                }}
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Credit" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-tachometer-alt"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.credit")}</span>
                            </NavLink>
                        </li>
                    )}
                    {/*Child credit activity*/}
                    {!isPrimaryAccount && (isCCAMActive || isIdfCCAMServiceActive) && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to={"/child-credit-activity"}
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Credit" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-list"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.creditActivity")}</span>
                            </NavLink>
                        </li>
                    )}
                    {employeeServiceAvailable() && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/employees"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Employees" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-user-friends"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.employees")}</span>
                            </NavLink>
                        </li>
                    )}
                    {employeeServiceAvailable() && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/mav/risk"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Mobile Attack View" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-mobile"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.mobileAttack")}</span>
                            </NavLink>
                        </li>
                    )}
                    {(isYodleeTransactionServiceActive || ismxServiceActive) && (
                        <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                            <NavLink
                                to="/transactions"
                                role="menuitem"
                                className="nav-link "
                                activeClassName="nav-active"
                                onClick={() => window.addToDataLayer({ event: "Nav Transactions" })}
                            >
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-exchange-alt"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.transactions")}</span>
                            </NavLink>
                        </li>
                    )}
                    {isLMSComplete && isLmsActiveService && (
                        <li
                            className={`${showTopNav ? "top-nav-item" : "nav-item"}`}
                            onClick={() => window.addToDataLayer({ event: "Nav Protection" })}
                            role="none"
                        >
                            <NavLink to="/protection" role="menuitem" className="nav-link " activeClassName="nav-active">
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-shield-alt"></em>
                                </span>
                                <span className="nav-text">{tLang("leftHandNavigation.protection")}</span>
                            </NavLink>
                        </li>
                    )}
                    {isAnyServiceActive &&
                       showResourceMenu() && (
                            <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                                <NavLink
                                    to="/resources/"
                                    role="menuitem"
                                    className="nav-link "
                                    activeClassName="nav-active"
                                    onClick={() => window.addToDataLayer({ event: "Nav Resources" })}
                                >
                                    <span className="nav-icon" aria-hidden="false">
                                        <em className="las la-book-open"></em>
                                    </span>
                                    <span className="nav-text">{tLang("leftHandNavigation.resources")}</span>
                                </NavLink>
                            </li>
                        )}
                    <li className={`${showTopNav ? "top-nav-item" : "nav-item"}`} role="none">
                        <NavLink
                            to={`${CyberActiveServices || IncidentActiveServices ? "/support" : "/supports"}`}
                            role="menuitem"
                            className="nav-link "
                            activeClassName="nav-active"
                            onClick={() => window.addToDataLayer({ event: "Nav Support" })}
                        >
                            <span className="nav-icon" aria-hidden="false">
                                <em className="las la-headset"></em>
                            </span>
                            <span className="nav-text">{tLang("leftHandNavigation.support")}</span>
                        </NavLink>
                    </li>
                    {showTopNav && (
                        <li className="top-nav-item" role="none" onClick={() => history.push("/manage-account/my-account")}>
                            <NavLink to="/manage-account" role="menuitem" className="nav-link " activeClassName="nav-active">
                                <span className="nav-icon" aria-hidden="false">
                                    <em className="las la-user"></em>
                                </span>
                                <span className="nav-text">Account</span>
                            </NavLink>
                        </li>
                    )}
                    {showTopNav && (
                        <li className="top-nav-item menu-top-header" style={{ padding: "12px 10px" }} role="none">
                            {renderFamilyService || !isPrimaryAccount ? (
                                <span className="nav-icon menu-top-header-icon" aria-hidden="false" onClick={toggleMenuBar}>
                                    <em className="las la-user-circle" style={{ fontSize: 24 }}></em>
                                </span>
                            ) : !isSSOUser && isPrimaryAccount ? (
                                <span
                                    className="nav-icon menu-top-header-icon"
                                    aria-hidden="false"
                                    onClick={(e) => {
                                        if (requestLogout) {
                                            requestLogout(e);
                                        }
                                    }}
                                >
                                    <em className="las la-sign-out-alt" style={{ fontSize: 24 }}></em>
                                </span>
                            ) : null}

                            {isOpen && <div className="menu-top-header-content">{renderFamilyService ? renderFamilyService() : null}</div>}
                        </li>
                    )}
                </ul>
            </div>
        </React.Fragment>
    );
};
